import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import getCountriesShipping from '../utils/react-query/query-options/get-countries-shipping';
import { useQuery } from '@tanstack/react-query';

const useData = () => {
  const {
    locale = 'en',
  } = useRouter();

  const {
    data: countriesShipping,
  } = useQuery(
    ...getCountriesShipping({
      locale,
    }),
    {
      keepPreviousData: true,
    }
  );

  return {
    countriesShipping,
  };
};

const PrivateAreaPage = dynamic(() => import('../components/pages/private-area'), {
  ssr: false,
});

//const CheckoutPage: typeof Checkout & TPageConfig = () => <Checkout />;

export default function CheckoutPage() {
  const data = useData();

  return (
    <main >
      <PrivateAreaPage {...data} />
    </main>
  );
};
